// src/data/shopsData.js
import shop1Img from '../../../../assets/images/home/shop1.jpg';
import shop2Img from '../../../../assets/images/home/shop2.jpg';
import shop3Img from '../../../../assets/images/home/shop3.jpg';
import shop4Img from '../../../../assets/images/home/shop4.jpg';
import tractorImg from '../../../../assets/images/home/tractor.jpg';
import tractor1Img from '../../../../assets/images/home/tractor1.jpg';
import tractor2Img from '../../../../assets/images/home/tractor2.jpg';
import tractor3Img from '../../../../assets/images/home/tractor3.jpg';
import tractor4Img from '../../../../assets/images/home/tractor4.jpg';
import tractor5Img from '../../../../assets/images/home/tractor5.jpg';
import tractor6Img from '../../../../assets/images/home/tractor6.jpg';
import harvestorImg from '../../../../assets/images/home/harvestor.jpg';
import harvestor1Img from '../../../../assets/images/home/harvestor1.jpg';
import seeddrillImg from '../../../../assets/images/home/seeddrill.png';
import seeddrill1Img from '../../../../assets/images/home/seeddrill1.jpg';
import sprayerImg from '../../../../assets/images/home/sprayer.jpg';
import sprayer1Img from '../../../../assets/images/home/sprayer1.jpg';
import discharrowImg from '../../../../assets/images/home/discharrow.jpg';
import rotavatorImg from '../../../../assets/images/home/rotavator.jpg';
import potatoplanterImg from '../../../../assets/images/home/potatoplanter.jpg';
import seedplanterImg from '../../../../assets/images/home/seedplanter.jpg';
import cultivatorImg from '../../../../assets/images/home/cultivator.jpg';
import irrigationImg from '../../../../assets/images/home/irrigation.jpg';
import thresherImg from '../../../../assets/images/home/thresher.jpg';
import cropthresherImg from '../../../../assets/images/home/cropthresher.jpg';
import ploughImg from '../../../../assets/images/home/plough.jpg';
import balerImg from '../../../../assets/images/home/baler.jpg';
import pumpImg from '../../../../assets/images/home/pump.jpg';
import trolleyImg from '../../../../assets/images/home/trolley.jpg';
import laserImg from '../../../../assets/images/home/laser.jpg';
import heavytractorImg from '../../../../assets/images/home/heavytractor.jpg';
import harvestor2Img from '../../../../assets/images/home/harvestor2.jpg';
import tillerImg from '../../../../assets/images/home/tiller.jpg';
import seeddrill2Img from '../../../../assets/images/home/seeddrill2.jpg';
import tractor7Img from '../../../../assets/images/home/tractor7.jpg';
import sprayer2Img from '../../../../assets/images/home/sprayer2.jpg';
import combineharvestorImg from '../../../../assets/images/home/combineharvestor.jpg';
import cultivator1Img from '../../../../assets/images/home/cultivator1.jpg';
import tractor8Img from '../../../../assets/images/home/tractor8.jpg';
import tractor9Img from '../../../../assets/images/home/tractor9.jpg';
import rotavator1Img from '../../../../assets/images/home/rotavator1.jpg';
import thresher1Img from '../../../../assets/images/home/thresher1.jpg';


export const shopsData = [
  {
    id: 1,
    name: 'Green Valley Farm Rentals',
    slug: 'green-valley-farm-rentals',
    banner: shop1Img,
    logo: shop1Img,
    rating: 4.7,
    totalReviews: 328,
    totalProducts: 45,
    followers: 1240,
    location: 'Faisalabad, Punjab',
    phone: '+92 300 1234567',
    email: 'info@greenvalleyfarm.pk',
    established: '2018',
    verified: true,
    description: 'Premium agricultural equipment rental and maintenance services with high-quality tractors, harvesters, and farming tools.',
    fullDescription:
  'SmartAgri Rent (Green Valley Farm Rentals) provides premium agricultural machinery rental and maintenance services. We offer modern tractors, harvesters, and farming equipment to support farmers with reliable, efficient, and timely solutions. Our focus is to improve productivity through well-maintained and high-performance machines.',
    category: 'Premium',
    featuredProducts: [
      { image: heavytractorImg },
      { image: harvestor2Img},
      { image: tillerImg },
    ],
    products: [
      {
        id: 101,
        name: 'John Deere 5075E Tractor',
        image: tractorImg,
        price: 2800,           // PKR/hr  — mid-large tractor, premium shop
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.8,
        category: 'Tractors',
        reviews: 42,
        condition: 'Excellent',
      },
      {
        id: 102,
        name: 'Case IH Axial Flow Harvester',
        image: harvestorImg,
        price: 7500,           // PKR/hr  — heavy combine harvester
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 5,
        category: 'Harvesters',
        reviews: 28,
        condition: 'Excellent',
      },
      {
        id: 103,
        name: 'Mahindra Arjun Tractor',
        image: tractor1Img,
        price: 1800,           // PKR/hr  — mid-range tractor, rented so slightly lower listed
        priceUnit: 'per hour',
        availability: 'Rented',
        rating: 4.5,
        category: 'Tractors',
        reviews: 35,
        condition: 'Good',
      },
      {
        id: 104,
        name: 'Kubota Seed Drill',
        image: seeddrillImg,
        price: 1200,           // PKR/hr  — seeder, medium category
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.6,
        category: 'Seeders',
        reviews: 19,
        condition: 'Excellent',
      },
      {
        id: 105,
        name: 'New Holland Crop Sprayer',
        image: sprayerImg,
        price: 900,            // PKR/hr  — boom sprayer
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.7,
        category: 'Sprayers',
        reviews: 24,
        condition: 'Good',
      },
      {
        id: 106,
        name: 'Massey Ferguson Disc Harrow',
        image: discharrowImg,
        price: 700,            // PKR/hr  — tiller/harrow, basic attachment
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.3,
        category: 'Tillers',
        reviews: 15,
        condition: 'Good',
      },
      {
        id: 107,
        name: 'Ford 4600 Tractor',
        image: tractor2Img,
        price: 1500,           // PKR/hr  — older Ford, good condition
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.4,
        category: 'Tractors',
        reviews: 31,
        condition: 'Good',
      },
      {
        id: 108,
        name: 'Grimme Potato Planter',
        image: potatoplanterImg,
        price: 1400,           // PKR/hr  — specialty planter
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.5,
        category: 'Planters',
        reviews: 12,
        condition: 'Excellent',
      },
    ],
  },

  // ─────────────────────────────────────────
  // SHOP 2 — Punjab Farm Equipment Co
  // ─────────────────────────────────────────
  {
    id: 2,
    name: 'Punjab Farm Equipment Co',
    slug: 'punjab-farm-equipment-co',
    category: "Standard",
    banner: shop2Img,
    logo: shop2Img,
    rating: 4.5,
    totalReviews: 256,
    totalProducts: 38,
    followers: 890,
    location: 'Lahore, Punjab',
    phone: '+92 301 9876543',
    email: 'contact@punjabfarm.pk',
    established: '2016',
    verified: true,
   description: 'Affordable and reliable farming equipment rental services for all types of agricultural needs.',
    fullDescription:
  'Punjab Farm Equipment Co (SmartAgri Rent partner) offers budget-friendly agricultural machinery rental services without compromising quality. Our equipment is regularly maintained and ideal for farmers looking for cost-effective solutions for cultivation, irrigation, and harvesting.',
    featuredProducts: [
      { image: seeddrill2Img },
      { image: tractor7Img },
      { image: sprayer2Img },
    ],
    products: [
      {
        id: 201,
        name: 'Massey Ferguson 240 Tractor',
        image: tractor3Img,
        price: 1400,           // PKR/hr  — popular local tractor, standard shop → affordable
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.4,
        category: 'Tractors',
        reviews: 38,
        condition: 'Good',
      },
      {
        id: 202,
        name: 'Land Master Seed Drill',
        image: seeddrill1Img,
        price: 900,            // PKR/hr  — local brand seeder
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.3,
        category: 'Seeders',
        reviews: 22,
        condition: 'Excellent',
      },
      {
        id: 203,
        name: 'Boom Sprayer 500L',
        image: sprayer1Img,
        price: 750,            // PKR/hr  — mid-size sprayer
        priceUnit: 'per hour',
        availability: 'Rented',
        rating: 4.2,
        category: 'Sprayers',
        reviews: 18,
        condition: 'Good',
      },
      {
        id: 204,
        name: 'Rotary Cultivator',
        image: cultivatorImg,
        price: 850,            // PKR/hr  — cultivator attachment
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.5,
        category: 'Cultivators',
        reviews: 25,
        condition: 'Good',
      },
      {
        id: 205,
        name: 'Water Bowser 2000L',
        image: irrigationImg,
        price: 500,            // PKR/hr  — irrigation/water carrier, budget
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.1,
        category: 'Irrigation',
        reviews: 14,
        condition: 'Good',
      },
      {
        id: 206,
        name: 'Wheat Thresher',
        image: thresherImg,
        price: 1600,           // PKR/hr  — seasonal high-demand machine
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.6,
        category: 'Threshers',
        reviews: 30,
        condition: 'Excellent',
      },
    ],
  },

  // ─────────────────────────────────────────
  // SHOP 3 — Ahmed Tractors & Machinery
  // ─────────────────────────────────────────
  {
    id: 3,
    name: 'Ahmed Tractors & Machinery',
    slug: 'ahmed-tractors-machinery',
     banner: shop3Img,
     logo: shop3Img,
     category: "Standard",
    rating: 4.8,
    totalReviews: 412,
    totalProducts: 52,
    followers: 1560,
    location: 'Multan, Punjab',
    phone: '+92 302 5551234',
    email: 'sales@ahmedtractors.pk',
    established: '2015',
    verified: true,
    description: 'Largest collection of modern and heavy-duty agricultural machinery in the region.',
    fullDescription:
  'Ahmed Tractors & Machinery is a premium SmartAgri Rent partner providing advanced agricultural machinery including high-end tractors, combine harvesters, and precision farming equipment. We support large-scale farming operations with powerful and efficient machines designed for maximum productivity.',
    featuredProducts: [
      { image: combineharvestorImg },
      { image: cultivator1Img },
      { image: tractor8Img },
    ],
    products: [
      {
        id: 301,
        name: 'New Holland TD5.110 Tractor',
        image: tractor4Img,
        price: 3200,           // PKR/hr  — modern large tractor, premium shop
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.9,
        category: 'Tractors',
        reviews: 56,
        condition: 'Excellent',
      },
      {
        id: 302,
        name: 'John Deere S780 Combine Harvester',
        image: harvestor1Img,
        price: 8500,           // PKR/hr  — top-of-line combine, highest price
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 5,
        category: 'Harvesters',
        reviews: 44,
        condition: 'Excellent',
      },
      {
        id: 303,
        name: 'Lemken Disc Plough',
        image: ploughImg,
        price: 1100,           // PKR/hr  — European brand plough
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.7,
        category: 'Ploughs',
        reviews: 33,
        condition: 'Excellent',
      },
      {
        id: 304,
        name: 'Precision Seed Planter',
        image: seedplanterImg,
        price: 1700,           // PKR/hr  — precision planter, higher end
        priceUnit: 'per hour',
        availability: 'Rented',
        rating: 4.8,
        category: 'Planters',
        reviews: 27,
        condition: 'Excellent',
      },
      {
        id: 305,
        name: 'Baler NH BR6090',
        image: balerImg,
        price: 3000,           // PKR/hr  — round baler, specialized machine
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.6,
        category: 'Balers',
        reviews: 21,
        condition: 'Excellent',
      },
      {
        id: 306,
        name: 'Irrigation Pump Set',
        image: pumpImg,
        price: 600,            // PKR/hr  — pump set, budget-friendly
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.5,
        category: 'Pumps',
        reviews: 38,
        condition: 'Good',
      },
      {
        id: 307,
        name: 'Kubota M7060 Tractor',
        image: tractor5Img,
        price: 3500,           // PKR/hr  — premium Japanese tractor, top of tractors
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.8,
        category: 'Tractors',
        reviews: 41,
        condition: 'Excellent',
      },
    ],
  },

  // ─────────────────────────────────────────
  // SHOP 4 — Sardar Farm Equipment
  // ─────────────────────────────────────────
  {
    id: 4,
    name: 'Sardar Farm Equipment',
    slug: 'sardar-farm-equipment',
    category: "PREMIUM",
    banner:shop4Img,
    logo: shop4Img,
    rating: 4.6,
    totalReviews: 198,
    totalProducts: 32,
    followers: 720,
    location: 'Gujranwala, Punjab',
    phone: '+92 303 7778888',
    email: 'info@sardarfarm.pk',
    established: '2019',
    verified: true,
    description: 'Trusted family-owned agricultural equipment rental service with flexible pricing and support.',
   fullDescription:
  'Sardar Farm Equipment is a reliable SmartAgri Rent partner offering agricultural machinery rental and maintenance services with a customer-first approach. We provide tractors, tillers, and farming tools with flexible rental plans designed for local farmers and seasonal needs.',
    category: 'Standard',
    featuredProducts: [
      { image: tractor9Img },
      { image: rotavator1Img },
      { image: thresher1Img },
    ],
    products: [
      {
        id: 401,
        name: 'Farmtrac 60 Classic Tractor',
        image: tractor6Img,
        price: 1200,           // PKR/hr  — entry-level tractor, standard shop
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.5,
        category: 'Tractors',
        reviews: 29,
        condition: 'Good',
      },
      {
        id: 402,
        name: 'Rotavator 6ft Heavy Duty',
        image: rotavatorImg,
        price: 650,            // PKR/hr  — rotavator attachment
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.4,
        category: 'Tillers',
        reviews: 22,
        condition: 'Good',
      },
      {
        id: 403,
        name: 'Multi Crop Thresher',
        image: cropthresherImg,
        price: 1800,           // PKR/hr  — versatile thresher, peak-season demand
        priceUnit: 'per hour',
        availability: 'Rented',
        rating: 4.6,
        category: 'Threshers',
        reviews: 26,
        condition: 'Excellent',
      },
      {
        id: 404,
        name: 'Trolley 4 Wheel',
        image: trolleyImg,
        price: 400,            // PKR/hr  — simple trailer, lowest price
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.2,
        category: 'Trailers',
        reviews: 18,
        condition: 'Good',
      },
      {
        id: 405,
        name: 'Laser Land Leveler',
        image: laserImg,
        price: 2200,           // PKR/hr  — laser leveler, specialized & in-demand
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.7,
        category: 'Levelers',
        reviews: 15,
        condition: 'Excellent',
      },
      {
        id: 406,
        name: 'Disc Harrow 24 Disc',
        image: discharrowImg,
        price: 800,            // PKR/hr  — harrow attachment
        priceUnit: 'per hour',
        availability: 'Available',
        rating: 4.3,
        category: 'Harrows',
        reviews: 20,
        condition: 'Good',
      },
    ],
  },
];